import { ISnippetBackend, ISnippet, createSnippet } from "./snippet";
import { IEditor, IEditorBackend, createEditor } from "./editor";
import { IUser, IUserBackend, IProfileBackend } from "./user";
import { ILabel } from "./label";

export interface IArticleBackend {
  id: number;
  name: string;
  snippets: ISnippetBackend[];
  updated_at: string;
  created_at: string;
  editor: IEditorBackend;
  path: string;
  owner: IUserBackend;
  labels: ILabel[];
}

export interface IArticle {
  id: number | null;
  name: string;
  snippets: ISnippet[];
  updatedAt: string;
  createdAt: string;
  editor: IEditor;
  path: string;
  owner: IUser;
  labels: ILabel[];
}

export const createArticle = (article: IArticleBackend): IArticle => {
  const snippets = article.snippets.map((snippet) => createSnippet(snippet));
  return Object.freeze({
    id: article.id,
    name: article.name,
    snippets: snippets,
    createdAt: article.created_at,
    updatedAt: article.updated_at,
    editor: createEditor(article.editor),
    path: article.path,
    owner: createUser(article.owner, article.owner.profile),
    labels: article.labels,
  });
};

export const createUser = (
  user: IUserBackend,
  profile: IProfileBackend
): IUser => {
  return Object.freeze({
    username: user.username,
    isPremium: user.is_premium,
    lastLogin: user.last_login,
    email: user.email,
    image: profile.image,
    company: profile.company,
    firstName: profile.first_name,
    lastName: profile.last_name,
    isFirstLogin: user.is_first_login,
  });
};

export const createArticles = (articles: IArticleBackend[]): IArticle[] => {
  return articles.map((article) => createArticle(article));
};
